export const MEDIA_URI = "http://104.199.127.60";
export const API_URI = "http://104.199.127.60/api";
export const isIPad = navigator.userAgent.match(/iPad/i);
export const isApp = window.location.protocol.indexOf('file') > -1;


// WEBPACK FOOTER //
// ./src/services/config.js